module.exports = __webpack_public_path__ + "static/media/Item_Weapon_MosinNagant_C.9e845558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_MosinNagant_C.png
// module id = 235
// module chunks = 0